import { addToCart, CONFIRM_MS } from 'cart-add';

/**
 * Add to cart from any product form, without leaving the page.
 *
 * A native product form posts to /cart/add and lands the customer on the cart
 * page, which throws away everything they had on screen. This intercepts the
 * submit and uses the same ajax path the kit builder uses, so both ways of
 * buying behave identically and the drawer is the only cart anyone sees.
 *
 * Loaded from the layout and delegated from the document, so a product form
 * anywhere in the theme is handled, however many a page holds.
 *
 * addToCart moves the badge on the click, says why when the cart refuses the
 * line, and opens the drawer once it is actually in; the button's "Adding"
 * spinner covers the wait.
 */

document.addEventListener('submit', (event) => {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form) return;

  event.preventDefault();
  submit(form);
});

async function submit(form) {
  if (form.dataset.adding) return;

  const item = lineFrom(form);
  if (!item.id) return;

  const button = form.querySelector('[data-add-button]');
  form.dataset.adding = 'true';
  setState(button, 'adding');

  const added = await addToCart({ items: [item], errorTarget: form.querySelector('[data-add-error]') });

  delete form.dataset.adding;
  setState(button, added ? 'added' : 'idle');

  if (added) setTimeout(() => setState(button, 'idle'), CONFIRM_MS);
}

/**
 * The line the form describes. Read from FormData rather than the fields
 * themselves so anything a block contributes — a selling plan, a line item
 * property — rides along without this file knowing about it.
 */
function lineFrom(form) {
  const data = new FormData(form);
  const item = {
    id: Number(data.get('id')),
    quantity: Math.max(1, Number(data.get('quantity')) || 1),
  };

  const plan = Number(data.get('selling_plan'));
  if (plan) item.selling_plan = plan;

  data.forEach((value, key) => {
    const property = key.match(/^properties\[(.+)\]$/);
    if (!property || value === '') return;
    item.properties = item.properties || {};
    item.properties[property[1]] = value;
  });

  return item;
}

/**
 * The button says what is happening. `data-state` drives the label swap and the
 * spinner in CSS, so no label text is written from here and translations stay
 * in Liquid.
 */
function setState(button, state) {
  if (!button) return;

  button.dataset.state = state;
  button.disabled = state === 'adding';
}
